import React from 'react';

import {useTranslation} from 'react-i18next';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {NavBar, NavLink} from 'components/ui-kit/NavBar';
import {ROUTE} from 'core/routes';

import {UserPermission} from 'types';

export const GridsNavigation = () => {
    const EXTRA_ACTIVE_PATH_FOR_DOCUMENTS = {
        [ROUTE.DOCUMENTS_INVOICES_INCOMING]: true,
        [ROUTE.DOCUMENTS_INVOICES_OUTGOING]: true,
    };
    const TRANSFER_PATHS = [
        ROUTE.DOCUMENTS_TRANSFER,
        ROUTE.DOCUMENTS_TRANSFER_INCOMING,
        ROUTE.DOCUMENTS_TRANSFER_OUTGOING,
    ];
    const {t} = useTranslation();
    return (
        <NavBar>
            <NavLink exact to={ROUTE.DOCUMENTS_DOCUMENTS}>
                {t('pages.documents.documents.gridName')}
            </NavLink>
            <PermissionAccess permissions={[UserPermission.INVOICE_TRANSFER_VIEW]}>
                <NavLink
                    isActive={(_match: any, location) =>
                        TRANSFER_PATHS.includes(location.pathname as ROUTE)
                    }
                    exact
                    to={ROUTE.DOCUMENTS_TRANSFER}
                >
                    {t('pages.documents.transfer.gridName')}
                </NavLink>
            </PermissionAccess>
            <NavLink
                isActive={(_match: any, location) =>
                    location.pathname in EXTRA_ACTIVE_PATH_FOR_DOCUMENTS
                }
                exact
                to={ROUTE.DOCUMENTS_INVOICES}
            >
                {t('pages.documents.invoices.gridName')}
            </NavLink>
            <NavLink
                isActive={(_match: any, location) => location.pathname === ROUTE.DOCUMENTS_MOVING}
                exact
                to={ROUTE.DOCUMENTS_MOVING}
            >
                {t('pages.documents.moving.gridName')}
            </NavLink>
            <PermissionAccess permissions={[UserPermission.DOCUMENT_VIEW_DROPOUT]}>
                <NavLink exact to={ROUTE.DOCUMENTS_WITHDRAWAL}>
                    {t('pages.documents.withdrawal.gridName')}
                </NavLink>
            </PermissionAccess>
            <PermissionAccess permissions={[UserPermission.DOCUMENTS_DECLARATION_LIST]}>
                <NavLink exact to={ROUTE.DOCUMENTS_GDS}>
                    {t('pages.documents.gds.gridName')}
                </NavLink>
            </PermissionAccess>
            <PermissionAccess
                permissions={[
                    UserPermission.RECEIPT_GRID_VIEW,
                    UserPermission.ALL_PRODUCT_GRID_VIEW,
                ]}
            >
                <NavLink exact to={ROUTE.DOCUMENTS_CHECKS}>
                    {t('pages.documents.checks.gridName')}
                </NavLink>
            </PermissionAccess>
            <PermissionAccess permissions={[UserPermission.MPL_BLOCKING_LIST_VIEW]}>
                <NavLink exact to={ROUTE.DOCUMENTS_BLOCKING}>
                    {t('pages.documents.blocking.gridName')}
                </NavLink>
            </PermissionAccess>
        </NavBar>
    );
};
